module.exports = __webpack_public_path__ + "static/media/movie-tully.494cf617.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/movies/movie-tully.jpg
// module id = 35
// module chunks = 0